import React from 'react';

import { LIVENESS_OPTIONS } from '@vlabs/api-bindings/src/luna-client/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const LivenessCheckboxesPopover = ({ onCountChange = undefined }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedLiveness = useWatch({ name: 'liveness' });
  const filterCount = Array.isArray(selectedLiveness) && selectedLiveness.length > 0 ? 1 : 0;
  useFilterCount('liveness', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="livenessFilter"
      triggerValue={t('Liveness')}
    >
      <CheckboxCustomFilter
        control={control}
        isMulti
        name="liveness"
        options={LIVENESS_OPTIONS.raw}
      />
    </CustomFilterPopover>
  );
};
